import * as Yup from "yup";

export type products = {
  searchName: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const productsInitialValues = {
  searchName: "",
  created_at: [null, null],
  updated_at: [null, null],
};

export const productsMandatoryFields = [];

export const productsValidationSchema = Yup.object().shape({
  created_at: Yup.array()
      .of(Yup.date().nullable())
      .test("is-range-complete", "End date is required", (value) => {
        if (!value) return true;
        const [start, end] = value;
        if (start && !end) return false;
        return true;
      }),
    updated_at: Yup.array()
      .of(Yup.date().nullable())
      .test("is-range-complete", "End date is required", (value) => {
        if (!value) return true;
        const [start, end] = value;
        if (start && !end) return false;
        return true;
      }),
});

export const productsProperties = [
  {
    id: "searchName",
    type: "text",
    label: "Product Name",
    Placeholder: "Enter Platform Name", 
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
